import { BsEnvelope } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const Header = () => {
  const navigate = useNavigate();

  return (
    <>
      <HeaderContainer>
        <Head>
          <LogoContainer>
            <Title
              onClick={() => {
                navigate("/");
                localStorage.setItem("where", "HOME");
              }}
            >
              RAPVI
            </Title>
            <FullTxtBox>
              <FullTxt>Risk Assessment Program</FullTxt>
              <FullTxt>for Vapor Intrusion</FullTxt>
            </FullTxtBox>
          </LogoContainer>
        </Head>

        <HorizontalMenu>
          <MenuWrapper>
            <HorizontalMenuTap
              onClick={() => {
                navigate("/");
                localStorage.setItem("where", "HOME");
              }}
            >
              기본정보
            </HorizontalMenuTap>

            <HorizontalMenuTap
              onClick={() => {
                navigate("/projectinfo");
              }}
            >
              RAPVI
            </HorizontalMenuTap>
            <HorizontalMenuTap onClick={() => navigate("/docs")}>
              자료실
            </HorizontalMenuTap>
          </MenuWrapper>
        </HorizontalMenu>
      </HeaderContainer>
    </>
  );
};

export default Header;

const HeaderContainer = styled.div`
  height: 10%;
`;

const HorizontalMenu = styled.div`
  background-color: rgb(141, 0, 42);
  padding: 0.1rem;
`;
const HorizontalMenuTap = styled.p`
  &:hover {
    cursor: pointer;
  }
  font-weight: 600;
  font-size: 1.3rem;
  color: white;
`;

const MenuWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
`;

const LogoContainer = styled.div`
  display: flex;
  margin: 2% 13%;
  align-items: center;
`;
const Logo = styled.img`
  width: 3rem;
  object-fit: contain;
  margin-top: 1rem;
`;

const Title = styled.p`
  color: rgb(141, 0, 42);
  font-size: 3rem;
  font-weight: 1000;
  margin: 0rem 1rem 0rem 1rem;
  &:hover {
    cursor: pointer;
  }
`;

const FullTxtBox = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 0.5rem;
`;

const FullTxt = styled.p`
  font-size: 1.1rem;
  font-weight: 700;
  margin: 0;
`;

const FAQdiv = styled.div`
  display: flex;
  align-items: flex-end;
  margin-bottom: 1rem;
  margin-right: 10%;
`;

const FAQ = styled.p`
  font-size: 1.1rem;
  font-weight: 700;
  margin: 0;
  &:hover {
    cursor: pointer;
  }
`;

const Head = styled.div`
  display: flex;
  justify-content: space-between;
`;
